import { Divider, Stack, useTheme } from "@mui/material";
import type { FC } from "react";
import type {
	ClientPortfolioDomainEnum,
	PortfolioListReportingSummaryResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { GroupedListLabel } from "web_myplann/Portfolio/Components/GroupedListLabel";
import { PortfolioListItemTitle } from "web_myplann/Portfolio/Components/PortfolioSections/PortfolioListItemTitle";
import type { GroupedPortfolioList } from "web_myplann/Portfolio/Hooks/useGroupPortfolio";

type Props = {
	list: GroupedPortfolioList;
	item: string;
	navigateToPortfolioDetail: (id: number) => void;
	setStickyTitle?: React.Dispatch<React.SetStateAction<string>>;
	summaryData: PortfolioListReportingSummaryResponseDTO[] | undefined;
};

export const GroupedPortfolioListItem: FC<Props> = ({
	item,
	list,
	navigateToPortfolioDetail,
	setStickyTitle,
	summaryData,
}) => {
	const { t } = useResource();
	const theme = useTheme();

	if (!list[item] || list[item].length === 0) {
		return null;
	}

	const title = t(
		Resources.Portfolio.List.PortfolioDomainType[
			item as ClientPortfolioDomainEnum
		],
	);

	return (
		<Stack>
			<GroupedListLabel title={title} setStickyTitle={setStickyTitle} />

			<Stack gap={1.6} mt={1.2} pb={1.6}>
				{list[item].map((portfolio, portfolioIndex) => (
					<Stack key={portfolio.id} gap={1.6}>
						<PortfolioListItemTitle
							data={portfolio}
							summaryData={summaryData}
							onClick={() => navigateToPortfolioDetail(portfolio.id)}
						/>
						{portfolioIndex < list[item].length - 1 && (
							<Stack px={1.6}>
								<Divider
									sx={{
										borderWidth: 0.75,
										borderColor: theme.palette.deprecated.grey[100],
									}}
								/>
							</Stack>
						)}
					</Stack>
				))}
			</Stack>
			<Divider
				sx={{
					borderWidth: 1.5,
					borderColor: theme.palette.deprecated.grey[100],
				}}
			/>
		</Stack>
	);
};
